// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckTile_container__36Flo"};